import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "types"
import { useApi } from "utils"

export const useDropdownGroupAsset = () => {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(true)

  useEffect(() => {
    api.get("/groupasset/")
    .then((res: SuccessFetch<{ payload: { mr_group_id: number, mr_group_name: string }[] }>) => { 
      setData(res.data.payload.map(item => { return { label: item.mr_group_name, value: item.mr_group_id.toString() }}))
    })
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}